const ViewSizeValuesPx = {
  SMALL: 0,
  MEDIUM: 576,
  LARGE: 992,
  EXTRA_LARGE: 1200
};
export const defaultViewSizes = {
  SMALL: ViewSizeValuesPx.SMALL,
  MEDIUM: ViewSizeValuesPx.MEDIUM,
  LARGE: ViewSizeValuesPx.LARGE,
  EXTRA_LARGE: ViewSizeValuesPx.EXTRA_LARGE
};
export const breakpoints = ["small", "medium", "large", "extra_large"];
